import { computed } from 'vue'

import { SessionProvider } from '@shared/plugins/session-provider'

import { PersonType } from '@protos/person_type_pb'

export const useSessionProvider = () => {
  const peerProps = computed(() => {
    return SessionProvider.getPeerProps()
  })
  const apiEssentials = computed(() => {
    return SessionProvider.apiEssentials()
  })
  const storedSession = computed(() => {
    return SessionProvider.getStoredSession()
  })

  const currentGroup = computed(() => {
    return SessionProvider.getStoredSession()?.currentGroup ?? null
  })

  const currentGroupName = computed(() => {
    return SessionProvider.getStoredSession()?.currentGroup?.name ?? null
  })

  const patientType = computed(() => {
    return currentGroup.value?.personType ?? PersonType.PERSON_PATIENT
  })

  const baseUrl = computed(() => {
    return SessionProvider.baseUrl()
  })

  const currentUser = computed(() => {
    return SessionProvider.getCurrentUser()
  })

  const apiHost = computed(() => {
    return (
      SessionProvider.getPeerProps()?.apiHost ||
      (process.env.VUE_APP_API_ROOT_URL as string)
    )
  })

  const wsParams = computed(() => {
    return SessionProvider.apiEssentials()?.wsParams
  })

  const isOwnedByCurrentUser = computed(() => {
    return currentGroup.value?.isOwnedByCurrentUser ?? false
  })

  const isSmsLogoSubscribed = computed(
    () => currentGroup.value?.isSmsLogoSubscribed ?? false
  )

  const isUsageLimitsEnabled = computed(() => {
    return currentGroup.value?.isUsageLimitsEnabled ?? false
  })

  const isEmrIntegrated = computed(() => {
    return (
      currentGroup.value?.isEmrIntegrationSubscribed &&
      currentGroup.value?.groupSettingEmrConnectionsEnabled.length
    )
  })

  const currentGroupTimezone = computed(() => currentGroup.value?.timezone)

  const isSuperAdmin = computed(() => !!storedSession.value?.impersonatedAs)

  const isSubgroup = computed(() => !!currentGroup.value?.parentGroup)

  const isAnnouncementEnabled = computed(
    () => currentGroup.value?.isAnnouncementsSubscribed
  )

  const createAbsoluteUrl = (path?: string): string =>
    `${SessionProvider.baseUrl()}${path ?? ''}`

  return {
    peerProps,
    storedSession,
    apiEssentials,
    baseUrl,
    currentUser,
    apiHost,
    wsParams,
    currentGroup,
    patientType,
    isOwnedByCurrentUser,
    isUsageLimitsEnabled,
    isAnnouncementEnabled,
    isEmrIntegrated,
    isSmsLogoSubscribed,
    isSuperAdmin,
    currentGroupName,
    currentGroupTimezone,
    isSubgroup,

    createAbsoluteUrl,
  }
}
